export default __webpack_public_path__ + "static/media/pantry2-after2-1024w.eb0fcc83.webp";